(function () {

    var version = '0.5.0';

    if (window.altspace && window.altspace.requestVersion) {
        window.altspace.requestVersion(version);
    }

}());